// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1SxQV","validationTips":"StatementDescriptor_validationTips__1gXKo"};